import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { ChainWideMerakisComponent } from '@app/features/merakis/modules/chain-wide-merakis/chain-wide-merakis.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    declarations: [
        ChainWideMerakisComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class ChainWideMerakisModule {}